import { Link } from 'react-router-dom';
import HeaderImg from '../assets/jactim-logo.png';

const Header = () => {
	return (
		<div className='container pt-5 pb-5'>
      <Link to="/">
        <img src={HeaderImg} alt="JACTIM" className='w-100 img-fluid' />
      </Link>
		</div>
	)
}

export default Header;